import React, { FC } from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { EditOutlined } from '@ant-design/icons';

const POLiGLCodeDisplay: FC<any> = ({ purchaseOrderLineItem, onEdit }): React.ReactElement => {
	return (
		<div className="flex flex-row items-center gap-2">
			<div>{nullSafeGetOrElse('glCode', purchaseOrderLineItem, '--')}</div>
			<EditOutlined onClick={onEdit} />
		</div>
	);
};

export default POLiGLCodeDisplay;
